<template>
    <div class="login-wrapper">
        <div class="login-box">
            <div class="login-banner">
                <img src="../assets/images/login-bg-2.png" alt="">
            </div>
            <div class="login-content">
                <div class="login-content-title">欢迎登录</div>
                <div class="login-content-text">短视频数据分析仿真平台</div>
                <div class="demo-ruleForm">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  label-position="top" label-width="100px" style="width:340px">
                        <el-form-item label="" prop="username">
                            <el-input v-model="ruleForm.username" class="login-input" placeholder="请输入您的账号"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input v-model="ruleForm.password" type="password" @keydown.enter.native="loginBtn('ruleForm')"
                                      class="login-input" placeholder="请输入您的账号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="medium" class="btn-orange" @click="loginBtn('ruleForm')">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="footer">
<!--            <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备15019684号-4</a>-->
        </div>
    </div>
</template>

<script>
    import {userLogin} from '@/utils/apis'
    export default {
        data() {
            return {
                ruleForm: {
                    username: '',
                    password: '',
                },
                rules: {
                    username: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                        { min: 3, max: 90, message: '长度在 3 到 90 个字符', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ],
                }
            }
        },
        methods: {
            loginBtn(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formData = new FormData()
                        formData.append('username', this.ruleForm.username)
                        formData.append('password', this.ruleForm.password)
                        userLogin(formData).then((res) => {
                            localStorage.setItem('role', res.data.role)
                            if (res.data.role === 1) {
                                localStorage.setItem('adminToken', res.data.token);
                                localStorage.setItem('adminName', res.data.nickname);
                                localStorage.setItem('adminAvatar', res.data.avatar);
                                localStorage.setItem('hosturl', res.data.hosturl);
                                this.$message.success(res.msg)
                                this.$router.push('/educational/school')
                            } else if (res.data.role === 2) {
                                localStorage.setItem('schoolToken', res.data.token);
                                localStorage.setItem('schoolName', res.data.nickname);
                                localStorage.setItem('schoolAvatar', res.data.avatar);
                                localStorage.setItem('hosturl', res.data.hosturl);
                                this.$message.success(res.msg)
                                this.$router.push('/school/educational/teacher')
                            } else if (res.data.role === 3) {
                                localStorage.setItem('teacherToken', res.data.token);
                                localStorage.setItem('teacherName', res.data.nickname);
                                localStorage.setItem('teacherAvatar', res.data.avatar);
                                localStorage.setItem('hosturl', res.data.hosturl);
                                this.$message.success(res.msg)
                                this.$router.push('/teachingCenter/index')
                            } else if (res.data.role === 4) {
                                localStorage.setItem('judgesToken', res.data.token);
                                localStorage.setItem('judgesName', res.data.nickname);
                                localStorage.setItem('judgesAvatar', res.data.avatar);
                                localStorage.setItem('hosturl', res.data.hosturl);
                                this.$message.success(res.msg)
                                this.$router.push('/judges/grading/index')
                            } else if (res.data.role === 5) {
                                localStorage.setItem('studentId', res.data.id);
                                localStorage.setItem('studentToken', res.data.token);
                                localStorage.setItem('studentName', res.data.nickname);
                                localStorage.setItem('studentAvatar', res.data.avatar);
                                localStorage.setItem('hosturl', res.data.hosturl);
                                this.$message.success(res.msg)
                                if (res.data.exam_id) {
                                    localStorage.setItem('examId', res.data.exam_id);
                                    this.$router.push('/student/exam')
                                } else {
                                    this.$router.push('/student/course/index')
                                }

                            }
                        }).catch((err) => {})
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .login-wrapper {
        min-width: 1200px;
        height: 100vh;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url(../assets/images/login-bg-1.png);
        .footer {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50px;
            text-align: center;
            line-height: 50px;
            a {
                color: #FFF;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .login-box {
            display: flex;
            width: 73%;
            height: 80%;
            background: #FFFFFF;
            /*box-shadow: 0 20px 40px 10px rgba(47, 24, 228, 0.5);*/
            border-radius: 30px;
        }
        .login-banner {
            width: 52%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            img {
                margin-left: 60px;
                max-width: 100%;
                max-height: 100%;
            }
        }

        .login-content {
            flex: 1;
            width: 1%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .login-content-title {
                width: 340px;
                font-size: 36px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 22px;
                text-align: left;
            }

            .login-content-text {
                position: relative;
                width: 340px;
                font-size: 30px;
                margin-bottom: 130px;
                padding-bottom: 20px;
                color: #3A3D40;
                &:before {
                    position: absolute;
                    bottom: 0;
                    display: inline-block;
                    content: '';
                    width: 40px;
                    height: 4px;
                    background: #EE3B2D;
                }
            }

            .el-form-item__label {
                line-height: 1.5;
            }

            .demo-ruleForm {
                ::v-deep .el-form-item {
                    margin-bottom: 40px;
                }
                .login-input {
                    ::v-deep .el-input__inner {
                        border-bottom: 2px solid #E5EBF2;
                        border-top: none;
                        border-left: none;
                        border-right: none;
                        border-radius: 0;
                    }
                }
                .el-button {
                    width: 100%;
                    height: 60px;
                    background-color: #D3251E;
                    border: 1px solid #D3251E;
                    border-radius: 30px;
                    margin-top:30px;
                    ::v-deep span {
                        font-size: 24px;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>